<template>
  <el-dialog :title="$t('task.dialog.editTitle')" :visible.sync="dialogVisible" width="500px" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item :label="$t('task.form.taskName')" prop="taskName">
        <el-input v-model="form.taskName" />
      </el-form-item>

      <el-form-item :label="$t('task.form.taskCron')" prop="taskCron">
        <el-select v-model="form.taskCron" placeholder="请选择运行时间" style="width: 100%">
          <el-option label="每1分钟第12秒执行" value="12 * * * * ?" />
          <el-option label="每1分钟执行一次" value="0 */1 * * * ?" />
          <el-option label="每5分钟执行一次" value="0 */5 * * * ?" />
          <el-option label="每10分钟执行一次" value="0 */10 * * * ?" />
          <el-option label="每20分钟执行一次" value="0 */20 * * * ?" />
          <el-option label="每30分钟执行一次" value="0 */30 * * * ?" />
          <el-option label="每小时执行一次" value="0 0 * * * ?" />
          <el-option label="每小时10分执行" value="0 10 * * * ?" />
          <el-option label="每1小时第12分钟执行" value="0 12 */1 * * ?" />
          <el-option label="每天0点执行" value="0 0 0 * * ?" />
          <el-option label="每天1点执行" value="0 0 1 * * ?" />
          <el-option label="每天12点32分执行" value="0 32 12 * * ?" />
          <el-option label="每天17点16分执行" value="0 16 17 * * ?" />
          <el-option label="每天18点37分执行" value="0 37 18 * * ?" />
          <el-option label="每天19点执行" value="0 0 19 * * ?" />
          <el-option label="每天23点执行" value="0 0 23 * * ?" />
          <el-option label="每周一9点执行" value="0 0 9 ? * MON" />
          <el-option label="每月1号1点30分执行" value="0 30 1 * * ?" />
          <el-option label="每月1号10点执行" value="0 0 10 1 * ?" />
          <el-option label="每月1号12点执行" value="0 0 12 1 * ?" />
          <el-option label="每年1月1日0点执行" value="0 0 0 1 1 ?" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('task.form.state')" prop="state">
        <el-select v-model="form.state" :placeholder="$t('task.form.state')" style="width: 100%">
          <el-option label="STOP" value="001" />
          <el-option label="RUN" value="002" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('task.dialog.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('task.dialog.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateTask } from '@/api/dev/taskApi'


export default {
  name: 'EditTask',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        taskId: '',
        taskName: '',
        templateId: '',
        taskCron: '',
        state: '',
        createTime: '',
      },
      rules: {
        taskId: [
          { required: true, message: this.$t('task.validate.taskId'), trigger: 'blur' }
        ],
        taskName: [
          { required: true, message: this.$t('task.validate.taskName'), trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: this.$t('task.validate.templateId'), trigger: 'blur' }
        ],
        taskCron: [
          { required: true, message: this.$t('task.validate.taskCron'), trigger: 'blur' }
        ],
        state: [
          { required: true, message: this.$t('task.validate.state'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('task.validate.createTime'), trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        if (val && this.formData) {
          this.form = { ...this.formData }
        }
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$refs.form && this.$refs.form.resetFields()
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await updateTask(this.form)
        this.$message.success(this.$t('common.operationSuccess'))
        this.handleClose()
        this.$emit('success')
      } catch (error) {
        console.error('编辑失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>
